<div
  [routerLink]="'/matches/details/' + match.id"
  class="match-card"
  *ngIf="match"
>
  <img
    class="match-card__image"
    [src]="match?.matchImage?.url || 'assets/images/placeholder-img.jpg'"
    alt=""
  />
  <div class="match-card__data">
    <div class="match-card__data-names">
      <span>
        {{
          translate.currentLang == "ar"
            ? match.teamHome.nameAr
            : match.teamHome.nameEn
        }}
      </span>
      <span class="px-1"> VS </span>
      <span>
        {{
          translate.currentLang == "ar"
            ? match.teamAway.nameAr
            : match.teamAway.nameEn
        }}
      </span>
    </div>

    <div class="match-card__data-champion">
      {{
        translate.currentLang == "ar"
          ? match.champion.nameAr
          : match.champion.nameEn
      }}
    </div>

    <div class="match-card__data-time">
      {{ formatDateTime(match.date, match.time, translate.currentLang) }}
    </div>

    <div class="match-card__data-stadium">
      {{
        translate.currentLang == "ar"
          ? match?.stadium.nameAr
          : match?.stadium.nameEn
      }}
    </div>
  </div>
</div>
